import template from './DataGroupOverviewPage.html'

const dataGroupOverviewPage = {
  bindings: {
    user: '<'
  },
  template,
  controller: /* @ngInject */ class DataGroupOverviewPageController {
    constructor (StoreService, $state, $location) {
      this.StoreService = StoreService
      this.$state = $state
      this.$location = $location
      this.urlParams = this.$state.params
    }
  }
}

export default dataGroupOverviewPage
